import {
  HttpEvent,
  HttpEventType,
  HttpProgressEvent,
} from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import {
  AcceptableFileTypes,
  FileUploadDialogData,
  PDFReportInformation,
  UserTargetSelectedFile,
  XeroxMessages,
} from 'src/app/core';
import { FilesService } from 'src/app/feature/services';

@Component({
  selector: 'app-file-upload-popup',
  templateUrl: './file-upload-popup.component.html',
  styleUrls: ['./file-upload-popup.component.scss'],
})
export class FileUploadPopupComponent implements OnInit {
  @Input('isDocSharing') isDocSharing: boolean = false;
  @Input('name') name!: string;

  private _subscriptions: Subscription[] = [];
  private set subscriptions(subscription: Subscription | undefined) {
    if (subscription) {
      this._subscriptions.push(subscription);
    }
  }

  public uploadProgress!: number;
  public fileUploading: boolean = false;
  public isFileUploaded: boolean = false;
  public isRangesSelected: boolean = false;
  public uploadFileReport!: PDFReportInformation;
  public acceptableFormats: string[] = [];

  constructor(
    private snakeBar: MatSnackBar,
    private filesService: FilesService,
    public dialogRef: MatDialogRef<FileUploadPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileUploadDialogData
  ) {
    this.generateAcceptableFormats();
  }

  public async ngOnInit(): Promise<void> {}

  public fileSelectionAdapter(event: UserTargetSelectedFile | Event) {
    if (event instanceof File) {
      this.uploadFile(event as File);
    }
  }

  async getAndUploadFromEvent(event: Event) {
    if (!(event as any)?.target?.files) {
      return this.say(XeroxMessages.FILE.failure.FILE_INPUT_EMPTY);
    }

    const file = (event as any).target.files[0] as File;
    const fileType = file.type;

    if (!this.checkSelectedFileType(fileType)) {
      return this.say(XeroxMessages.FILE.failure.FILE_TYPE_NOT_ACCEPTED);
    }

    if (!this.data?.immediate) {
      return this.close(file);
    }

    await this.uploadFile(file);
  }

  async uploadFile(file: File) {
    if (!this.data.immediate) return;

    const that = this;

    this.filesService
      .uploadFileWithProgress({
        file,
        name: this.data.name || 'unknown',
        urlName: this.data.urlName,
        apiVersion: this.data.apiVersion,
        isDocSharing: this.isDocSharing,
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              that.fileUploading = true;
              break;

            case HttpEventType.UploadProgress:
              this.uploadProgress = this.calculateProgress(event);
              break;

            case HttpEventType.Response:
              let data = event.body;

              that.fileUploading = false;
              that.isFileUploaded = true;
              that.uploadFileReport = data;

              this.close(data);
          }
        },
        (error) => {
          console.error(error);
          this.say('مشکل در آپلود فایل');
        }
      );
  }

  generateFileUploadStatus(percent: number): string {
    const message = 'در حال آپلود: ' + percent + '%';
    return message;
  }

  close(data?: PDFReportInformation | File) {
    this.dialogRef.close(data);
  }

  private checkSelectedFileType(fileType: unknown) {
    const types = this.data.acceptableTypes;
    return types.indexOf(fileType as AcceptableFileTypes) < 0 ? false : true;
  }

  public generateAcceptableFormats() {
    this.acceptableFormats = this.data.acceptableTypes.map((value) => {
      return value.split('/')[1];
    });
  }

  generateAcceptForInput() {
    return this.data.acceptableTypes.join(',')
  }

  private calculateProgress(event: HttpProgressEvent) {
    return Math.round((event.loaded / (event as any).total) * 100);
  }

  private say(msg: string) {
    this.snakeBar.open(msg, '', { duration: 2000 });
  }
}
